import type { Variants } from '@ds/components/Tag'

import type { OrderlineBundledMobilePlanStateLabelClass } from '~/api/my-orders/types/OrderlineBundledMobilePlan.types'

export const MOBILE_PLAN_STATE_VARIABLES: Record<
  OrderlineBundledMobilePlanStateLabelClass,
  Variants
> = {
  DEFAULT: 'info',
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
}
